var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.auth.user.selectedAccess.can_manage_staff)?_c('div',[_c('app-header',{attrs:{"title":_vm.$store.getters['translations/getLabel']('STAFF') || 'Staff'}}),_c('b-container',[_c('StaffList')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }